/**
 * Remembering which train he is on across a reload.
 *
 * Held only in memory, the pin was lost on any cold start, and the app filled the gap from the
 * recommendation — which answers "what should I catch from here", so reopening the phone a
 * minute out of Rockridge named the next departure and the card began describing a train he was
 * not on. The storage format lives here, away from React, so it can be tested.
 */

export interface StoredPin {
	date: string;
	id: string | null;
}

/** A pin belongs to the day it was made; yesterday's train is not a candidate for this morning. */
export function parsePin(raw: string | null, todayKey: string): string | null {
	if (!raw) {
		return null;
	}
	try {
		const stored = JSON.parse(raw) as Partial<StoredPin>;
		if (stored?.date !== todayKey || typeof stored.id !== "string") {
			return null;
		}
		return stored.id;
	} catch {
		return null;
	}
}

export function serialisePin(id: string | null, todayKey: string): string {
	return JSON.stringify({ date: todayKey, id } satisfies StoredPin);
}
